import React, { useState, useEffect, useRef, useContext } from "react";

import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast, ToastContainer } from "react-toastify";
import cloneDeep from 'lodash/cloneDeep';
import * as turf from '@turf/turf';


import { useDispatch, useSelector } from "react-redux";


import { useTranslation } from "react-i18next";

import FormHandler from "../Common/Form/FormHandler/FormHandler";

import { blockuserdetailss, createincidentsitu, createMasterResource, editincident, findAllChildrenRegionsById, getconfigdatacate, getgpdetails, getincidentcatcreate, getMasterResourceByIdURL, getpanchaycentersa, getstatusdetails, getThemeURL, resourceActivityListURL, resourceCatListURL, updateincident } from "../../../Services/EndPoints";
import { setRegFilesToStore } from "../../../CentralStore/RegistrationsSlice/registrationSlice";
import { IncidentResourceConfig, incidentresourceschema } from "../../../JsonData/IncidentResourceConfig";
import Tree from "rc-tree";
import RegionNode from "../RegionManagement/RegionList/RegionTree/RegionNode";
import RMMap from "../RegionManagement/RMMap/RMMap";
import { getData, postDataWithBody, putDataWithBody } from "../../../Services/Services";
import IncidentMap from "../RegionManagement/RMMap/IncidentMap";
import IncidentTable from "../GisincidentManagement/IncidentTable";
import { ClockFading } from "lucide-react";
import { ClockHistory } from "react-bootstrap-icons";
import { ThemeContext } from "../../..";


const CreateIncidentFormPage = () => {
  const [masterresourceConfig, setMasterResourceConfig] = useState(
    IncidentResourceConfig
  );
  const [resourceCategoriesList, setResourceCategoriesList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [masterCategory, setMasterCategory] = useState(null);
  const [status, setStatus] = useState("");
  const [selctedblockid, setselctedblockid] = useState(null)
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const { state } = useLocation();
  const dispatch = useDispatch();
  let id = state?.id;
  let edit = state?.edit;
const { theme } = useContext(ThemeContext);
  let imgName = state?.imgName;
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(incidentresourceschema[activeTab]),
    mode: "all",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [districtId, setDistrictId] = useState("");
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedBlockIds, setSelectedBlockIds] = useState([]);
  const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
  const [selectedVillageIds, setSelectedVillageIds] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [regionTypeId, setRegionTypeId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [keyVal, setKeyVal] = useState("");
  const [actionTypeHeader, setActionTypeHeader] = useState("");
  const [id1, setId] = useState(null);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const regionDataMap = useRef(new Map()).current;
  const [selectedPanchayat, setSelectedPanchayat] = useState([]);
  const [statusarray, setstatusarray] = useState([])
  const [searchValue, setSearchValue] = useState('');
  const [confirmedRegions, setConfirmedRegions] = useState({
    selectedRegions: [],
    selectedDistrictIds: [],
    selectedBlockIds: [],
    selectedPanchayatIds: [],
    selectedVillageIds: []
  });
  const [panchaycent, setpanchaycent] = useState([])
  const handleShow = () => setShowPopup(true);
  const handleClose = () => setShowPopup(false);
  // Sample data - similar to your data structure
  const [data, setData] = useState([]);
  const [username, setusername] = useState("")
  const [expandedKeys, setExpandedKeys] = useState(['52']); // Start with Bihar expanded
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  // Status array - exactly like yours
  useEffect(() => {
    const initializeForm = async () => {
      await getInitFormData(); // Load category options first
      if (id) {
        await getupdateDetails(); // Then load incident data
        // Then load incident data
      }
    };
    initializeForm();
  }, [id]);

  // useEffect(() => {
  //   if (id) {
  //     getupdateDetails()
  //   }

  // }, [id])
  useEffect(() => {
    if (id && checkedKeys.length > 0) {
      const keysToExpand = new Set();

      checkedKeys.forEach(key => {
        const parts = key.split('-');
        for (let i = 1; i < parts.length; i++) {
          keysToExpand.add(parts.slice(0, i).join('-'));
        }
      });

      setExpandedKeys(Array.from(keysToExpand));
      setAutoExpandParent(true);
    }
  }, [id, checkedKeys]);
  console.log("checkedKeys", checkedKeys)
  console.log("previous checked ")
  useEffect(() => {
    getstatusDeails()
    getUserdataprof()
  }, [])
  const formatForInput = (date) => {
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const getupdateDetails = async () => {
    try {
      const req = [id];
      const response = await postDataWithBody(updateincident, req, {});
      console.log("response", response);

      if (response && response.basicinfo && response.basicinfo.length > 0) {
        const incidentData = response.basicinfo[0];
        console.log("incidentdata", incidentData);

        // Process users data
        const formattedUsers = response.users ? response.users.map(user => ({
          value: user.id.toString(),
          label: user.user_name,
          userData: user
        })) : [];


        // Update user dropdown options
        setMasterResourceConfig(prevConfig => {
          const updatedConfig = cloneDeep(prevConfig);
          const userField = updatedConfig[0].fields.find(f => f.name === "userlist");

          if (userField) {
            userField.options = [
              {
                value: "all",
                label: `All Users (${response.users.map(u => u.user_name).join(', ')})`,
                users: response.users
              },
              ...formattedUsers
            ];
          }
          return updatedConfig;
        });

        // Set form value for users
        setValue("userlist", formattedUsers);

        // Process regions data
        const regionsData = response.regions || [];
        const processedRegions = regionsData.map(region => ({
          gpcode: region.gpcode,
          block: region.block,
          dist: region.dist,
          name: region.name,
          regionid: region.regionid.toString(),
          id: region.regionid.toString(),
          text: region.name,
          status: (region?.status ?? '507').toString(),
          dist_gis_id: region.dist_gis_id,
          block_gis_id: region.block_gis_id,
          gis_id: region.gis_id,
          dist_id: region.dist_id,
          block_id: region.block_id
        }));

        setData(processedRegions);

        // Generate the complete tree hierarchy and check the regions
        if (regionsData.length > 0) {
          const stateKey = "52"; // Bihar
          const allCheckedKeys = [];
          const allExpandedKeys = [stateKey];
          const selectedRegions = [];
          const selectedPanchayatIds = [];

          // Process each region to build the hierarchy
          regionsData.forEach(region => {
            const districtKey = `${stateKey}-${region.dist_gis_id}`;
            const blockKey = `${districtKey}-${region.block_gis_id}`;
            const panchayatKey = `${blockKey}-${region.gis_id}`;

            // Add keys to checked and expanded lists if not already present
            if (!allCheckedKeys.includes(districtKey)) allCheckedKeys.push(districtKey);
            if (!allCheckedKeys.includes(blockKey)) allCheckedKeys.push(blockKey);
            allCheckedKeys.push(panchayatKey);

            if (!allExpandedKeys.includes(districtKey)) allExpandedKeys.push(districtKey);
            if (!allExpandedKeys.includes(blockKey)) allExpandedKeys.push(blockKey);

            // Add district if not already added
            if (!selectedRegions.some(r => r.level === 1 && r.gis_id === region.dist_gis_id)) {
              selectedRegions.push({
                name: region.dist,
                gis_id: region.dist_gis_id,
                id: region.dist_id,
                region_type_id: 1,
                level: 1
              });
            }

            // Add block if not already added
            if (!selectedRegions.some(r => r.level === 2 && r.gis_id === region.block_gis_id)) {
              selectedRegions.push({
                name: region.block,
                gis_id: region.block_gis_id,
                id: region.block_id,
                region_type_id: 2,
                level: 2
              });
            }

            // Add panchayat
            selectedRegions.push({
              name: region.name,
              gis_id: region.gis_id,
              id: region.regionid,
              region_type_id: 3,
              level: 3
            });

            selectedPanchayatIds.push(region.gis_id);
          });

          // Get block ID from first region (assuming all regions share the same block)
          const blockId = regionsData[0].block_id;
          getblockiduserdetails(blockId, formattedUsers);

          // Set the checked and expanded keys
          setCheckedKeys(allCheckedKeys);
          setExpandedKeys(allExpandedKeys);
          setAutoExpandParent(true);

          // Set the selected regions state
          setSelectedRegions(selectedRegions);
          setSelectedDistrictIds([...new Set(regionsData.map(r => r.dist_gis_id))]);
          setSelectedBlockIds([...new Set(regionsData.map(r => r.block_gis_id))]);
          setSelectedPanchayatIds(selectedPanchayatIds);
          setSelectedVillageIds([]);

          setConfirmedRegions({
            selectedRegions,
            selectedDistrictIds: [...new Set(regionsData.map(r => r.dist_gis_id))],
            selectedBlockIds: [...new Set(regionsData.map(r => r.block_gis_id))],
            selectedPanchayatIds: selectedPanchayatIds,
            selectedVillageIds: []
          });

          // Set panchayat data for the table
          setSelectedPanchayat(selectedRegions.filter(r => r.level === 3));

        }

        // Process time
        const timeString = incidentData.time;
        if (timeString) {
          const [datePart, timePart, ampm] = timeString.trim().split(' ');
          const [day, monthStr, year] = datePart.split('-');
          const [hours, minutes, seconds] = timePart.split(':');

          let hour = parseInt(hours, 10);
          if (ampm === 'PM' && hour < 12) hour += 12;
          if (ampm === 'AM' && hour === 12) hour = 0;

          const monthIndex = new Date(Date.parse(monthStr + " 1, 2000")).getMonth();

          const dateObj = new Date(
            parseInt(year, 10),
            monthIndex,
            parseInt(day, 10),
            hour,
            parseInt(minutes, 10),
            parseInt(seconds, 10)
          );

          // Set form values
          reset({
            incidentname: incidentData.name,
            incidentcategory: incidentData.category,
            incidentdatetime: formatForInput(dateObj),
            incidentDes: incidentData.description,
            userlist: formattedUsers
          });
        } else {
          reset({
            incidentname: incidentData.name,
            incidentcategory: incidentData.cat,
            incidentDes: incidentData.description,
            userlist: formattedUsers
          });
        }
      }
    } catch (error) {
      console.error("Error fetching incident details:", error);
      toast.error("Failed to load incident details", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };


  const generateRegionPathKeys = (regionData) => {
    if (!regionData) return {};

    const stateKey = "52";
    const districtKey = `${stateKey}-${regionData.dist_gis_id}`;
    const blockKey = `${districtKey}-${regionData.block_gis_id}`;
    const panchayatKey = `${blockKey}-${regionData.gis_id}`;

    return {
      stateKey,
      districtKey,
      blockKey,
      panchayatKey,
      allKeys: [districtKey, blockKey, panchayatKey],
      parentKeys: [stateKey, districtKey, blockKey]
    };
  };



  const getUserdataprof = async () => {
    try {
      const usr_prof = await getData(getThemeURL);
      setusername(usr_prof[0].user_name)

    } catch (error) {

    }
  }
  const getstatusDeails = async () => {
    try {
      const request = { "code": "INCIDENT_REGION_STATUS" }
      const sta_det = await postDataWithBody(getstatusdetails, request, {})
      setstatusarray(sta_det)

    } catch (error) {

    }
  }

  useEffect(() => {
    window.regionTreeComponent = {
      showModalPopup,
      hideModalPopup
    };

    // Add Bihar to the regionDataMap
    regionDataMap.set("52", {
      name: "BIHAR",
      id: 52,
      region_type_id: null,
      gis_id: null,
      level: 0
    });

    const timer = setTimeout(() => {
      setTreeData([{
        title: "BIHAR",
        key: "52",
        checkable: false
      }]);
    }, 100);

    return () => clearTimeout(timer);
  }, []);
  const onLoadData = (treeNode) => {
    console.log("load data...");
    return new Promise(async (resolve, reject) => {
      const newTreeData = [...treeData];
      let regionList = await generateTreeNodes(treeNode);
      getNewTreeData(newTreeData, treeNode.props.eventKey, regionList, 5);
      setTreeData(newTreeData);

      // After loading the data, check if we need to auto-select any regions
      if (data.length > 0) {
        const region = data[0];
        const currentKey = treeNode.props.eventKey;

        // Check if this node is part of our target region's path
        const pathKeys = generateRegionPathKeys({
          dist_gis_id: parseInt(region.dist_gis_id),
          block_gis_id: parseInt(region.block_gis_id),
          gis_id: parseInt(region.gis_id)
        });

        // If the current key matches any of our path keys, check it
        if (Object.values(pathKeys).includes(currentKey)) {
          setCheckedKeys(prev => [...new Set([...prev, currentKey])]);

          // If this is a parent node, expand it
          if (currentKey !== pathKeys.panchayatKey) {
            setExpandedKeys(prev => [...new Set([...prev, currentKey])]);
          }
        }
      }

      resolve();
    });
  };


  const hideModalPopup = () => {
    setShowPopup(false);
  };
  const generateTreeNodes = async (treeNode) => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const { keySanitized, level, isLastNode } = getHierarchyInfo(key);

    const rgnList = await postDataWithBody(findAllChildrenRegionsById, [keySanitized], {});

    rgnList.forEach((region) => {
      const keyVal = `${key}-${region.id}`;
      const newLevel = level + 1;

      // Store region data in the map
      regionDataMap.set(keyVal, {
        name: region.name,
        id: region.id,
        region_type_id: region.region_type_id,
        gis_id: region.gis_id,
        level: newLevel,
      });



      // Check if this region should be auto-selected
      const shouldCheck = data.some(item =>
        (newLevel === 1 && item.dist_gis_id === region.gis_id) ||
        (newLevel === 2 && item.block_gis_id === region.gis_id) ||
        (newLevel === 3 && item.gis_id === region.gis_id)
      );

      if (shouldCheck) {
        setCheckedKeys(prev => [...prev, keyVal]);
        if (newLevel < 3) { // Only expand parent nodes (state, district, block)
          setExpandedKeys(prev => [...prev, keyVal]);
        }
      }

      const isDistrictLevel = newLevel === 1;
      const isLeaf = newLevel >= 3;

      arr.push({
        title: (
          <RegionNode
            regionTypeId={region.region_type_id}
            isLastNode={isLeaf}
            keyVal={keyVal}
            selectedId={handleSelectedId}
            id={region.id}
            text={region.name}
            displayNewUI={true}
          />
        ),
        key: keyVal,
        isLeaf: isLeaf,
        checkable: !isDistrictLevel,
      });
    });

    return arr;
  };
  const getHierarchyInfo = (key) => {
    let keySanitized = null;
    let level = 0;
    let isLastNode = false;

    if (key.indexOf("-") > -1) {
      const keyParts = key.split("-");
      level = keyParts.length - 1; // 1=District, 2=Block, 3=Panchayat, 4=Village

      // Village is the last level (level 4)
      if (keyParts.length === 5) { // Bihar-District-Block-Panchayat-Village
        isLastNode = true;
      }
      keySanitized = keyParts[keyParts.length - 1];
    } else {
      keySanitized = key;
      level = 0; // Bihar level
    }

    return { keySanitized, level, isLastNode };
  };
  const setLeaf = (treeData, curKey, level) => {
    const loopLeaf = (data, lev) => {
      const l = lev - 1;
      data.forEach((item) => {
        if (
          item.key.length > curKey.length
            ? item.key.indexOf(curKey) !== 0
            : curKey.indexOf(item.key) !== 0
        ) {
          return;
        }
        if (item.children) {
          loopLeaf(item.children, l);
        } else if (l < 1) {
          item.isLeaf = true;
        }
      });
    };
    loopLeaf(treeData, level + 1);
  };
  const getNewTreeData = (treeData, curKey, child, level) => {
    const loop = (data) => {
      if (level < 1) return;
      data.forEach((item) => {
        if (curKey.indexOf(item.key) === 0) {
          if (item.children) {
            loop(item.children);
          } else {
            item.children = child;
          }
        }
      });
    };
    loop(treeData);
    setLeaf(treeData, curKey, level);
  };
  const getAllChildKeys = (treeData, parentKey) => {
    const descendants = [];

    const findChildren = (nodes) => {
      nodes.forEach(node => {
        if (node.key.startsWith(parentKey + '-')) {
          descendants.push(node.key);
          if (node.children) {
            findChildren(node.children);
          }
        }
      });
    };

    findChildren(treeData);
    return descendants;
  };
  const handleSelectedId = (idval, type, keyVal, regionTypeId) => {
    showModalPopup(idval, type, keyVal, regionTypeId);
  };
  const showModalPopup = (id, type, keyVal, regionTypeId) => {
    let actionTypeStr = type === "EDIT" ? "Edit Region Information" : "Create Region";
    setRegionTypeId(regionTypeId);
    setShowPopup(true);
    setActionType(type);
    setKeyVal(keyVal);
    setActionTypeHeader(actionTypeStr);
    setId(id);

  };
  const processIndividualNode = async (nodeKey, regionData, checkedKeys, regions, districts, blocks, panchayats, villages, isChecking) => {
    if (isChecking) {
      // Add current node
      if (regionData.gis_id) {
        switch (regionData.level) {
          case 1: // District
            districts.push(regionData.gis_id);
            break;
          case 2: // Block
            blocks.push(regionData.gis_id);
            break;
          case 3: // Panchayat
            panchayats.push(regionData.gis_id);
            break;
          case 4: // Village
            villages.push(regionData.gis_id);
            break;
        }
      }

      regions.push({
        name: regionData.name,
        gis_id: regionData.gis_id,
        id: regionData.id,
        region_type_id: regionData.region_type_id,
        level: regionData.level
      });

      // Also check all children if this is not a leaf node
      if (regionData.level < 4) {
        const allChildKeys = getAllChildKeys(treeData, nodeKey);
        for (const childKey of allChildKeys) {
          if (!checkedKeys.includes(childKey)) {
            checkedKeys.push(childKey);
            const childData = regionDataMap.get(childKey);
            if (childData) {
              regions.push({
                name: childData.name,
                gis_id: childData.gis_id,
                id: childData.id,
                region_type_id: childData.region_type_id,
                level: childData.level
              });

              if (childData.gis_id) {
                switch (childData.level) {
                  case 1: districts.push(childData.gis_id); break;
                  case 2: blocks.push(childData.gis_id); break;
                  case 3: panchayats.push(childData.gis_id); break;
                  case 4: villages.push(childData.gis_id); break;
                }
              }
            }
          }
        }
      }
    } else {
      // Unchecking - remove current node and all children
      const keysToRemove = [nodeKey, ...getAllChildKeys(treeData, nodeKey)];

      for (const keyToRemove of keysToRemove) {
        // Remove from checked keys
        const index = checkedKeys.indexOf(keyToRemove);
        if (index > -1) {
          checkedKeys.splice(index, 1);
        }

        // Remove from regions and category arrays
        const dataToRemove = regionDataMap.get(keyToRemove);
        if (dataToRemove) {
          // Remove from regions
          const regionIndex = regions.findIndex(r => r.id === dataToRemove.id);
          if (regionIndex > -1) {
            regions.splice(regionIndex, 1);
          }

          // Remove from appropriate category
          if (dataToRemove.gis_id) {
            switch (dataToRemove.level) {
              case 1:
                removeFromArray(districts, dataToRemove.gis_id);
                break;
              case 2:
                removeFromArray(blocks, dataToRemove.gis_id);
                break;
              case 3:
                removeFromArray(panchayats, dataToRemove.gis_id);
                break;
              case 4:
                removeFromArray(villages, dataToRemove.gis_id);
                break;
            }
          }
        }
      }
    }
  };
  const removeFromArray = (array, item) => {
    const index = array.indexOf(item);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
  useEffect(() => {
    if (imgName) {
      setValue("resource_image_name", imgName);  // Set imgName as the default value
    }
  }, [imgName, setValue]);

  const rscractivity = useWatch({
    control,
    name: "activity",
  });
  useEffect(() => {
    getInitFormData();
  }, [t]);
  useEffect(() => {
    const rscractivity = getValues("activity");
    if (rscractivity && rscractivity != "") {
      getCategoryByActivity(rscractivity);
    }
  }, [rscractivity]);
  const getInitFormData = async () => {
    setLoader(true);
    await getActivityList();
    setLoader(false);
  };

  const getActivityList = async () => {
    const req = { code: "INCDNT_CAT" };
    const activityList1 = await postDataWithBody(getconfigdatacate, req, {});

    const activityList = Array.isArray(activityList1) ? activityList1 : [];

    const options = activityList.map(item => ({
      value: item.incidentcategory || item.value || '',
      label: item.incidentcategory || item.label || ''
    }));

    const updatedConfig = cloneDeep(masterresourceConfig);

    updatedConfig[0].fields[1].options = [
      { label: t('masterresourceplaceholder.select'), value: "" },
      ...options
    ];

    setMasterResourceConfig(updatedConfig);
    console.log('Updated config:', updatedConfig[0].fields[1].options);
  };

  const getCategoryByActivity = async (activity) => {
    if (activity != "") {
      var resourceCategoryList = await getData(resourceCatListURL + activity);
      for (let resourceCat in resourceCategoryList) {
        resourceCategoryList[resourceCat]["label"] =
          resourceCategoryList[resourceCat]["category"];
        resourceCategoryList[resourceCat]["value"] =
          resourceCategoryList[resourceCat]["category"];
      }
      masterresourceConfig[0].fields[1]["options"] = [
        { label: t('masterresourceplaceholder.select'), value: "" },
      ].concat(resourceCategoryList);
    } else {
      masterresourceConfig[0].fields[1]["options"] = [
        { label: t('masterresourceplaceholder.select'), value: "" },
      ];
      setMasterResourceConfig(masterresourceConfig);
    }
    setMasterResourceConfig(masterresourceConfig);
    setResourceCategoriesList(resourceCategoryList);
    if (id) {
      await getMasterResourceList();
    }
  };
  async function getMasterResourceList() {
    let masterResourceList = await postDataWithBody(
      getMasterResourceByIdURL,
      [id],
      {}
    );
    console.log("masterResourceList:", masterResourceList);
    masterResourceList = masterResourceList[0];
    reset(masterResourceList);
    setMasterCategory(masterResourceList.category);
    //  id &&
    //    imageFields?.forEach((field) => {
    //      const imageId = masterResourceList[field];
    //      setValue(field, imageId);
    //    });
  }
  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        <FormHandler
          register={register}
          errors={errors}
          fields={fields.map(field => {
            // Disable incidentcategory field in edit mode
            if (edit && field.name === "incidentcategory") {
              return {
                ...field,
                disabled: true
              };
            }
            return field;
          })}
          control={control}
          // onChange={onChange}
          setValue={setValue}
          columns={2}
          getValues={getValues}
          imgName={imgName}
          handleShow={handleShow}
          textareaConfig={true}
        />
      </div>
    );
  };
  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };
  const regions = data.map(panchayat => ({
    gpcode: panchayat.gpcode,
    block: panchayat.block,
    dist: panchayat.dist,
    name: panchayat.name,
    regionid: panchayat.regionid.toString(),
    id: panchayat.regionid.toString(),
    text: panchayat.name,
    status: (panchayat?.status ?? '507').toString() // Default status
  }));

  const submitHandler = async (data, e) => {
    console.log("Form data before processing:", data);
    e.preventDefault();
    setIsSubmitting(true)
    setLoader(true);
    //   const selectedOption = masterresourceConfig[0].fields[4].options.find(
    //   opt => opt.value === data.user
    // );

    // let usersToAssign = [];

    // if (data.user === "all") {
    //   // If "All Users" is selected, use all user data
    //   usersToAssign = selectedOption.users;
    // } else {
    //   // Otherwise use the single selected user data
    //   usersToAssign = [selectedOption.userData];
    // }
    let usersRaw = [];

    if (Array.isArray(data.userlist)) {
      const firstEntry = data.userlist[0];

      // If every item has id + user_name directly
      if (data.userlist.every(user => user?.id && user?.user_name)) {
        usersRaw = data.userlist;
        console.log("Direct array of user objects");

        // If entries contain userData object
      } else if (data.userlist.every(user => user?.userData?.id && user?.userData?.user_name)) {
        usersRaw = data.userlist.map(user => user.userData);
        console.log("Extracted from userData array");

        // Older formats — nested structures
      } else if (Array.isArray(firstEntry?.users)) {
        usersRaw = firstEntry.users;
        console.log("Nested in 'users'");

      } else if (Array.isArray(firstEntry?.userData)) {
        usersRaw = firstEntry.userData;
        console.log("Nested in 'userData' array");

      } else if (Array.isArray(firstEntry?.userlist)) {
        usersRaw = firstEntry.userlist;
        console.log("Nested in 'userlist'");

      } else if (firstEntry?.id && firstEntry?.user_name) {
        usersRaw = [firstEntry];
        console.log("Single user object");

      } else {
        console.log("Unknown structure in userlist[0]:", firstEntry);
      }
    } else if (data.userlist?.id && data.userlist?.user_name) {
      usersRaw = [data.userlist];
      console.log("userlist is single user object");
    } else {
      console.log("userlist is neither array nor user object:", data.userlist);
    }

    console.log("Final usersRaw:", usersRaw);


    const usersToAssign = usersRaw.map(user => ({
      id: user.id,
      user_name: user.user_name
    }));

    const dateObj = new Date(data.incidentdatetime);

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // convert 0 to 12 for 12 AM
    const paddedHours = String(hours).padStart(2, '0'); // 👉 Add this

    const formatted = `${year}/${month}/${day} ${paddedHours}:${minutes} ${ampm}`;
    const centerCoords = await getpanchaycenters();

    const req = {
      "regions": regions,
      "basicinfo": {
        ...(id && { id }),
        "name": data.incidentname,
        "category": parseInt(data.incidentcategory, 10) || 0,
        "time": formatted,
        "desc": data.incidentDes,
        "userId": username,
        "gisconfig": JSON.stringify({
          incidentcenter: centerCoords || [87.481559325, 26.141488627]
        })
      },
      users: usersToAssign
    }
    // Format the date/time properly
    console.log("re7899", req)
    if (edit) {
      try {
        // Add await here to properly wait for the response
        const res = await putDataWithBody(editincident, req, {});

        // Check response status properly (assuming res has a status property)
        if (res && res.status === "success") {
          toast.success(res.msg || "Incident updated successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });

          // Navigate after showing the toast
          setTimeout(() => {
            navigate("/situation-awareness/incident-management");
          }, 2000); // Wait for toast to show before navigating

          dispatch(setRegFilesToStore({ type: "reset" }));
        } else {
          toast.error(res.msg || "Failed to update incident", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          setIsSubmitting(false)
          setLoader(false);
        }
      } catch (error) {
        console.error("Update error:", error);
        toast.error("An error occurred during update", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setIsSubmitting(false)
      } finally {
        setLoader(false);
        setIsSubmitting(false)
      }


    } else {
      try {
        const res = await postDataWithBody(createincidentsitu, req, {});
        console.log("response403", res)
        if (res.status == "success") {
          toast.success(res.msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("/situation-awareness/incident-management")
          console.log("Submitted data:", data);
          dispatch(setRegFilesToStore({ type: "reset" }));
        } else {
          toast.error(res.msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          setIsSubmitting(false)
          setLoader(false);
        }
      } catch (error) {
        console.error("Submission error:", error);
        toast.error("An error occurred during submission", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setIsSubmitting(false)
      } finally {
        setLoader(false);
        setIsSubmitting(false)
      }
    }
  };
  const handleStatusClick = (item) => {
    console.log("Clicked on status dropdown for:", item.regionid);
    const currentStatus = statusarray.find(s => s.value === item.status)?.label || "Not Set";
    console.log(`Current Status: ${currentStatus}`);
  };
  const findKeyForRegion = (regionId) => {
    for (const [key, value] of regionDataMap.entries()) {
      if (value.id === regionId) return key;
    }
    return null;
  };
  const [activeBlockKey, setActiveBlockKey] = useState("");


  // Improved descendant key finder

  const onCheck = async (checkedKeysRaw, info) => {
    console.log("onCheck triggered", checkedKeysRaw);
    setIsLoading(true);

    try {
      let currentCheckedKeys = Array.isArray(checkedKeysRaw)
        ? checkedKeysRaw
        : checkedKeysRaw.checked || [];

      const node = info.node;
      const nodeKey = node.key;
      const regionData = regionDataMap.get(nodeKey);

      let allCheckedKeys = [...currentCheckedKeys];
      let newSelectedRegions = [];
      let newSelectedDistrictIds = [];
      let newSelectedBlockIds = [];
      let newSelectedPanchayatIds = [];
      let newSelectedVillageIds = [];
      let newSelectedBlockId = selctedblockid;

      // Handle block selection (level 2)
      if (regionData?.level === 2) {
        if (info.checked) {
          // Clear all previously selected blocks and their panchayats
          allCheckedKeys = allCheckedKeys.filter(k => {
            const data = regionDataMap.get(k);
            return !(data?.level === 2 || data?.level === 3);
          });

          // Add the new block and all its panchayats
          newSelectedBlockId = regionData.id;
          allCheckedKeys.push(nodeKey);

          const children = await generateTreeNodes({ props: { eventKey: nodeKey } });
          const panchayatKeys = children
            .filter(child => regionDataMap.get(child.key)?.level === 3)
            .map(child => child.key);
          allCheckedKeys.push(...panchayatKeys);
        } else {
          // When unchecking a block, remove it and all its panchayats
          allCheckedKeys = allCheckedKeys.filter(k =>
            k !== nodeKey && !k.startsWith(`${nodeKey}-`)
          );
          newSelectedBlockId = null;
        }
      }
      // Handle GP (panchayat) selection (level 3)
      else if (regionData?.level === 3) {
        const parentBlockKey = nodeKey.split('-').slice(0, -1).join('-');
        const parentBlockData = regionDataMap.get(parentBlockKey);

        if (info.checked) {
          // 🔍 Find all existing selected Panchayats (level 3)
          const selectedGPs = allCheckedKeys.filter(k => regionDataMap.get(k)?.level === 3);

          // 🔍 Check if the selected Panchayats belong to a different block
          const hasDifferentBlock = selectedGPs.some(k => {
            const existingGPParentKey = k.split('-').slice(0, -1).join('-');
            return existingGPParentKey !== parentBlockKey;
          });

          if (hasDifferentBlock) {
            // 🧹 Clear all GPs and Blocks if selecting from a new block
            allCheckedKeys = allCheckedKeys.filter(k => {
              const data = regionDataMap.get(k);
              return data?.level !== 3 && data?.level !== 2;
            });
          }

          // ✅ Add parent block if not already added
          if (!allCheckedKeys.includes(parentBlockKey)) {
            allCheckedKeys.push(parentBlockKey);
            newSelectedBlockId = parentBlockData?.id;
          }

          // ✅ Add the current Panchayat
          if (!allCheckedKeys.includes(nodeKey)) {
            allCheckedKeys.push(nodeKey);
          }
        } else {
          // ❌ Unchecking a Panchayat
          allCheckedKeys = allCheckedKeys.filter(k => k !== nodeKey);

          // 🧹 Remove parent block if no more GPs under it
          const hasSiblingGPs = allCheckedKeys.some(
            k => k.startsWith(parentBlockKey + '-') && regionDataMap.get(k)?.level === 3
          );

          if (!hasSiblingGPs) {
            allCheckedKeys = allCheckedKeys.filter(k => k !== parentBlockKey);
          }
        }
      }



      // Process all checked keys to build region selections
      for (const key of allCheckedKeys) {
        const data = regionDataMap.get(key);
        if (!data) continue;

        newSelectedRegions.push({
          name: data.name,
          gis_id: data.gis_id,
          id: data.id,
          region_type_id: data.region_type_id,
          level: data.level
        });

        if (data.gis_id) {
          switch (data.level) {
            case 1: newSelectedDistrictIds.push(data.gis_id); break;
            case 2: newSelectedBlockIds.push(data.gis_id); break;
            case 3: newSelectedPanchayatIds.push(data.gis_id); break;
            case 4: newSelectedVillageIds.push(data.gis_id); break;
          }
        }
      }

      // Update all states
      setCheckedKeys(allCheckedKeys);
      setSelectedRegions(newSelectedRegions);
      setSelectedDistrictIds(newSelectedDistrictIds);
      setSelectedBlockIds(newSelectedBlockIds);
      setSelectedPanchayatIds(newSelectedPanchayatIds);
      setSelectedVillageIds(newSelectedVillageIds);
      setselctedblockid(newSelectedBlockId);

      // Immediately update confirmed regions for the map
      setConfirmedRegions({
        selectedRegions: newSelectedRegions,
        selectedDistrictIds: newSelectedDistrictIds,
        selectedBlockIds: newSelectedBlockIds,
        selectedPanchayatIds: newSelectedPanchayatIds,
        selectedVillageIds: newSelectedVillageIds
      });

      // Update panchayat data for the table
      const panchayats = newSelectedRegions.filter(r => r.level === 3);
      setSelectedPanchayat(panchayats);
      await getGpDetailsForTable(panchayats);

      // If we have a new block ID, fetch user details
      if (newSelectedBlockId) {
        await getblockiduserdetails(newSelectedBlockId);
      }

      // Set district ID for map focus
      if (newSelectedDistrictIds.length > 0) {
        setDistrictId(newSelectedDistrictIds[0]);
      }
    } catch (error) {
      console.error("onCheck error", error);
      toast.error("Error updating region selection", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };



  const getGpDetailsForTable = async (panchayats) => {
    try {
      if (panchayats.length > 0) {
        const panchayatIds = panchayats.map(p => p.id);
        const response = await postDataWithBody(getgpdetails, panchayatIds, {});

        if (response) {
          // Merge API data with our local panchayat data
          const enhancedData = response.map(item => {
            const localData = panchayats.find(p => p.id === item.regionid);
            return {
              ...item,
              block: localData?.blockName || '',
              dist: localData?.districtName || '',
              status: item.status || '507',
              id: item.regionid.toString(),
              text: item.name
            };
          });
          setData(enhancedData);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching GP details:", error);
    }
  };


  const getAllDescendantKeys = (treeData, parentKey) => {
    const descendants = [];

    const traverse = (nodes) => {
      nodes.forEach(node => {
        if (node.key.startsWith(`${parentKey}-`)) {
          descendants.push(node.key);
          if (node.children) traverse(node.children);
        }
      });
    };

    traverse(treeData);
    return descendants;
  };
  // Add this new function to handle panchayat clicks
  const handlePanchayatClick = (panchayatData) => {


    // You can do whatever you need with the panchayat data here
    // For example, store it in state, make an API call, etc.

    // Example: Store the selected panchayat in state
    setSelectedPanchayat(prev => {
      const exists = prev.find(p => p.id === panchayatData.id);
      if (!exists) {
        return [...prev, panchayatData];
      }
      return prev;
    });

    // Example: Show an alert

  };
  const getGpDetaislval = async () => {
    try {
      const ids = selectedPanchayat.map(p => p.id);
      console.log("idddd", ids)
      const response = await postDataWithBody(getgpdetails, ids, {})
      if (response) {
        setData(response)
      }
    } catch (error) {

    }
  }
  const handleRemove = (regionid) => {
    console.log(`Remove clicked for region ${regionid}`);

    // 1. Find the region data from the data array (table data)
    const regionToRemove = data.find(item => item.regionid === regionid);
    if (!regionToRemove) return;

    // 2. Update the data state (table data)
    setData(prevData => prevData.filter(item => item.regionid !== regionid));

    // 3. Update the checkedKeys state (tree checkboxes)
    setCheckedKeys(prevKeys => {
      // Find the key in regionDataMap that corresponds to this regionid
      const regionEntry = Array.from(regionDataMap.entries()).find(
        ([key, value]) => value.id.toString() === regionid.toString()
      );

      if (!regionEntry) return prevKeys;

      const [key] = regionEntry;
      return prevKeys.filter(k => k !== key);
    });

    // 4. Update the selectedRegions state
    setSelectedRegions(prev => prev.filter(r => r.id.toString() !== regionid.toString()));

    // 5. Update the specific ID arrays based on the region level
    // First find the region data from regionDataMap
    const regionEntry = Array.from(regionDataMap.entries()).find(
      ([key, value]) => value.id.toString() === regionid.toString()
    );

    if (!regionEntry) return;

    const [key, regionData] = regionEntry;

    switch (regionData.level) {
      case 1: // District
        setSelectedDistrictIds(prev => prev.filter(id => id !== regionData.gis_id));
        break;
      case 2: // Block
        setSelectedBlockIds(prev => prev.filter(id => id !== regionData.gis_id));
        break;
      case 3: // Panchayat
        setSelectedPanchayatIds(prev => prev.filter(id => id !== regionData.gis_id));
        setSelectedPanchayat(prev => prev.filter(p => p.id.toString() !== regionid.toString()));
        break;
      case 4: // Village
        setSelectedVillageIds(prev => prev.filter(id => id !== regionData.gis_id));
        break;
    }

    // 6. Update confirmedRegions state
    setConfirmedRegions(prev => ({
      ...prev,
      selectedRegions: prev.selectedRegions.filter(r => r.id.toString() !== regionid.toString()),
      selectedDistrictIds:
        regionData.level === 1
          ? prev.selectedDistrictIds.filter(id => id !== regionData.gis_id)
          : prev.selectedDistrictIds,
      selectedBlockIds:
        regionData.level === 2
          ? prev.selectedBlockIds.filter(id => id !== regionData.gis_id)
          : prev.selectedBlockIds,
      selectedPanchayatIds:
        regionData.level === 3
          ? prev.selectedPanchayatIds.filter(id => id !== regionData.gis_id)
          : prev.selectedPanchayatIds,
      selectedVillageIds:
        regionData.level === 4
          ? prev.selectedVillageIds.filter(id => id !== regionData.gis_id)
          : prev.selectedVillageIds
    }));
  };
  const getGeometricdetails = async () => {
    try {
      //const metricdetails =await 
    } catch (eror) {

    }
  }
  const getpanchaycenters = async () => {
    try {

      const res = await postDataWithBody(getpanchaycentersa, selectedPanchayatIds, {})
      if (res) {
        // Parse the center coordinates from each item in the response
        const centers = res.map(item => {
          const centerObj = JSON.parse(item.center);
          return centerObj.coordinates; // Returns [longitude, latitude]
        });

        setpanchaycent(centers); // This will store array of coordinate arrays

        // If you need to calculate the center point of all these coordinates
        if (centers.length > 0) {
          const features = turf.points(centers);
          const centerPoint = turf.center(features);
          console.log('Geographic center:', centerPoint.geometry.coordinates);

          // You can use this center point for your map
          return centerPoint.geometry.coordinates;
        }
      }

    } catch (error) {

    }
  }
  const getblockiduserdetails = async (blockid, preSelectedUsers = []) => {
    try {
      const userendpoint = blockuserdetailss.replace('{ID}', blockid);
      const response = await getData(userendpoint);
      const activeUsers = response.filter(user => !user.is_deleted);
      setUsers(activeUsers); // Just for reference

      const allUsernames = activeUsers.map(user => user.user_name).join(', ');

      // Build dropdown options
      const allUserOptions = [
        {
          value: "all",
          label: "All Users",  // (${allUsernames})
          users: activeUsers
        },
        ...activeUsers.map(user => ({
          value: user.id.toString(),
          label: user.user_name,
          userData: user
        }))
      ];

      // ✅ Set dropdown options
      setMasterResourceConfig(prevConfig => {
        const updatedConfig = cloneDeep(prevConfig);
        const userField = updatedConfig[0].fields.find(f => f.name === "userlist");
        if (userField) userField.options = allUserOptions;
        return updatedConfig;
      });

      // ✅ Retain previously selected users if passed
      if (preSelectedUsers?.length > 0) {
        setValue("userlist", preSelectedUsers);
      }

    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };


  const tabsData = generateTabsData(masterresourceConfig);
  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      return data; // Return all data if search is empty
    }

    const lowercasedSearch = searchTerm.toLowerCase();

    return data.filter(item =>
      item.name.toLowerCase().includes(lowercasedSearch) ||
      item.dist.toLowerCase().includes(lowercasedSearch) ||
      item.block.toLowerCase().includes(lowercasedSearch) ||
      (item.status && statusarray.find(s => s.value === item.status)?.label.toLowerCase().includes(lowercasedSearch)) ||
      item.regionid.toString().includes(lowercasedSearch)
    );
  };
  const onSelect = (info) => {
    console.log("selected", info);
  };
  const filteredData = handleSearch(searchValue);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const tableBody = currentItems.map((item) => (
    <tr key={item.regionid} style={{ borderBottom: '1px solid #ddd' }}>
      <td style={{ padding: '15px 20px', textAlign: 'left', color: theme === "light" ? "#000000" : "white", fontSize: '11px' }}>
        {item.regionid}
      </td>
      <td style={{ padding: '15px 20px', textAlign: 'left', color: theme === "light" ? "#000000" : "white", fontSize: '11px' }}>
        {item.name}
      </td>
      <td style={{ padding: '15px 20px', textAlign: 'left', color: theme === "light" ? "#000000" : "white", fontSize: '11px' }}>
        {item.dist}
      </td>
      <td style={{ padding: '15px 20px', textAlign: 'left', color: theme === "light" ? "#000000" : "white", fontSize: '11px' }}>
        {item.block}
      </td>
      <td style={{ padding: '15px 20px', textAlign: 'left', fontSize: '11px' }}>
        <select
          value={item.status || ""}
          onClick={() => handleStatusClick(item)}
          onChange={(e) => handleStatusChange(item.regionid, parseInt(e.target.value))}
          style={{
            padding: '5px 10px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44",
            color: theme === "light" ? "#000000" : "white",
            cursor: 'pointer',
            minWidth: '120px'
          }}
        >
         
          {/* Map over status_array to show all three options for EVERY record */}
          {statusarray.map((status) => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </select>
      </td>
      <td style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px' }}>
        <button
          onClick={() => {
            handleRemove(item.regionid)
          }}
          style={{
            backgroundColor: '#ffc107',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '3px',
            cursor: 'pointer'
          }}
        >
          Remove
        </button>
      </td>
    </tr>
  ));

  const handleStatusChange = (regionid, newStatus) => {


    // Update the data state with new status
    setData(prevData =>
      prevData.map(item =>
        item.regionid === regionid
          ? { ...item, status: newStatus }
          : item
      )
    );

    // Get the status label for display
    const statusLabel = statusarray.find(s => s.value === newStatus)?.label;

  };

  const onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys);
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };


  return (
    <div className="mt-4">
      <div className="form-body">
        <div className="registration__form--body">
          <form
            onSubmit={handleSubmit(submitHandler)}
            name="MasterResourceRegForm"
          >
            <div>
              {tabsData?.map((tab) => (
                <>
                  {tab.id === activeTab && (
                    <>
                      <div className="registration__form--heading">
                        {tab.heading}
                      </div>
                      <div>{tab.component}</div>
                    </>
                  )}
                </>
              ))}
            </div>

            <div className="d-flex justify-content-center">
              {tabsData.length - 1 === activeTab && (
                <Button type="submit" className="mx-2" variant="primary" disabled={isSubmitting || loader}>
                  {edit ? "Update" : t('Save & Submit')}
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>

      {/* Map View Section */}
      <div style={{ margin: '20px 0', marginTop: '30px' }}>
        <IncidentMap
          selectedRegions={confirmedRegions.selectedRegions}
          selectedDistrictIds={confirmedRegions.selectedDistrictIds}
          selectedBlockIds={confirmedRegions.selectedBlockIds}
          selectedPanchayatIds={confirmedRegions.selectedPanchayatIds}
          selectedVillageIds={confirmedRegions.selectedVillageIds}
          selectedDistrictId={districtId}
          isLoading={isLoading}
        />
      </div>

      {/* Table Section */}
      <div style={{ margin: '10px 0', marginTop: '-40px' }}>

        <div style={{backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", padding: '10px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <label style={{ color: theme === "light" ? "#000000" : "white", marginRight: '10px', fontSize: '11px' }} htmlFor="search">Search:</label>
          <input
            type="text"
            id="search"
            placeholder="Search..."
            value={searchValue} // controlled value
            onChange={(e) => setSearchValue(e.target.value)} // update state
            style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '11px', width: '200px' }}
          />
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table id="dataTable" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44" }}>
            <thead style={{ backgroundColor: '#252b48' }}>
              <tr>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>ID</th>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>Gram Panchayat</th>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>District</th>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>Block</th>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>Status</th>
                <th style={{ padding: '15px 20px', textAlign: 'left', color: 'white', fontSize: '11px', backgroundColor: '#18a3a0' }}>Action</th>
              </tr>
            </thead>
            <tbody id="tableBody">
              {tableBody}
            </tbody>
          </table>

          {/* <div id="noDataMessage" style={{ textAlign: 'center', padding: '40px 20px', color: '#666', fontSize: '14px', backgroundColor: '#252b48' }}>
              No data available in table
            </div> */}

        </div>


        <div style={{ backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44", padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ color: theme === "light" ? "#000000" : "white", fontSize: '14px' }}>
            Showing <span id="showingStart">{indexOfFirstItem + 1}</span> to <span id="showingEnd">{Math.min(indexOfLastItem, filteredData.length)}</span> of <span>{filteredData.length}</span> entries
          </div>
          <div style={{ display: 'flex', gap: '5px' }}>
            {/* Previous Button */}
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
                color: currentPage === 1 ? '#999' : '#666',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                borderRadius: '4px',
                fontSize: '11px'
              }}
            >
              Previous
            </button>

            {/* Always show first page button if not already visible */}
            {currentPage > 3 && (
              <>
                <button
                  onClick={() => setCurrentPage(1)}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ddd',
                    backgroundColor: currentPage === 1 ? '#18a3a0' : 'white',
                    color: currentPage === 1 ? 'white' : '#666',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    fontSize: '11px'
                  }}
                >
                  1
                </button>
                {currentPage > 4 && (
                  <span style={{ color: 'white', padding: '8px', display: 'flex', alignItems: 'center' }}>...</span>
                )}
              </>
            )}

            {/* Dynamic page numbers - show pages around current page */}
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                // Show all pages if total pages is 5 or less
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                // Show first 5 pages when near start
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                // Show last 5 pages when near end
                pageNum = totalPages - 4 + i;
              } else {
                // Show 2 pages before and after current page
                pageNum = currentPage - 2 + i;
              }

              if (pageNum < 1 || pageNum > totalPages) return null;

              return (
                <button
                  key={pageNum}
                  onClick={() => setCurrentPage(pageNum)}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ddd',
                    backgroundColor: currentPage === pageNum ? '#18a3a0' : 'white',
                    color: currentPage === pageNum ? 'white' : '#666',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    fontSize: '11px'
                  }}
                >
                  {pageNum}
                </button>
              );
            })}

            {/* Show ellipsis and last page if needed */}
            {currentPage < totalPages - 3 && (
              <>
                {currentPage < totalPages - 4 && (
                  <span style={{ color: 'white', padding: '8px', display: 'flex', alignItems: 'center' }}>...</span>
                )}
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ddd',
                    backgroundColor: currentPage === totalPages ? '#18a3a0' : 'white',
                    color: currentPage === totalPages ? 'white' : '#666',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    fontSize: '11px'
                  }}
                >
                  {totalPages}
                </button>
              </>
            )}

            {/* Next Button */}
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
                color: currentPage === totalPages ? '#999' : '#666',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                borderRadius: '4px',
                fontSize: '11px'
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Region Selection Popup */}
      {showPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1050,
          width: '100%'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '5px',
            width: '80%',
            maxWidth: '900px',
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Header */}
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #dee2e6',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#252b48'
            }}>
              <h5 style={{ margin: 0, color: 'white' }}>Add Region</h5>
              <button
                onClick={handleClose}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'white'
                }}
              >
                &times;
              </button>
            </div>

            {/* Body */}
            <div style={{
              padding: '16px',
              flex: 1,
              overflow: 'auto',
              width: '100%',
              height: '600px'
            }}>
              <Tree
                onSelect={onSelect}
                onCheck={onCheck}
                loadData={onLoadData}
                onExpand={onExpand}
                treeData={treeData}
                checkable={true}
                checkedKeys={checkedKeys}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                checkStrictly={true}
                showLine={true}
                style={{ color: 'black' }}
              />
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px',
              borderTop: '1px solid #dee2e6',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
              backgroundColor: '#252b48'
            }}>
              <button
                onClick={handleClose}
                style={{
                  padding: '6px 12px',
                  borderRadius: '4px',
                  border: '1px solid #6c757d',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
              <button
                onClick={async () => {
                  // handle your save logic here
                  setConfirmedRegions({
                    selectedRegions,
                    selectedDistrictIds,
                    selectedBlockIds,
                    selectedPanchayatIds,
                    selectedVillageIds
                  });
                  handleClose();
                  getGpDetaislval()
                  getGeometricdetails()
                  getpanchaycenters()
                  const currentBlockId = selectedRegions.find(r => r.level === 2)?.id || selctedblockid;
                  if (currentBlockId) {
                    await getblockiduserdetails(currentBlockId);
                  }
                }}
                style={{
                  padding: '6px 12px',
                  borderRadius: '4px',
                  border: '1px solid #007bff',
                  backgroundColor: '#007bff',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Select Region
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CreateIncidentFormPage;
